import Vicente101 from '../../../Media/Produk/New Launch/Vicente 10.webp'
import Vicente102 from '../../../Media/Produk/New Launch/Layout 10.webp'

const Vicente10images =[
Vicente101,Vicente102
]

export default Vicente10images;